import { link } from '@sparta.global.helpers/sparta-helper/dist/es6.js';

/* global spaParams */

/* eslint-disable no-param-reassign */

/**
   * Helper function to create secure link
   *
   * @param {Object} config - Sparta link config
   * @param {String} secureHost - secure host to create links to
   * @returns {Object} the linked helper
   */
function secureLink(config, secureHost) {
  if (config) {
    if (Object.prototype.hasOwnProperty.call(config, 'URL')) {
      if (!/^http.+/i.test(config.URL)) {
        if (!secureHost || typeof secureHost !== 'string') {
          if (typeof spaParams !== 'undefined' && spaParams.siteParams) {
            secureHost = spaParams.siteParams.secureHost;
          } else {
            throw new Error('secureHost is not defined and is necessary for secureLink helper');
          }
        }
        config.URL = secureHost + config.URL;
      }
    } else {
      throw new Error('config is missing URL property!');
    }
  } else {
    throw new Error('config is undefined and is necessary for secureLink helper');
  }
  return link(config);
}

// Export helpers
/**
 * {{secureLink}}
 *
 * Wrapper around sparta link helper. Create links from www to secure
 * space as though they were relative links within www space. Supports
 * any configuration supported by Sparta link helper. More info:
 * http://wiki.bankofamerica.com/display/borneoui2/Sparta-link
 *
 * @syntax:
 *   {{ secureLink config }}
 * @usage:
 *   {{secureLink reference.to.jcr.link.config}}
 *
 * @class secureLink
 */

export { secureLink };
